<template>
    <div class="body-container" style="height: 100%" @scroll="scrollEvent" id="container">
      <div class="upper-part" id="upper-part">
        <section class="banner-wrap" v-if="bannerList.length > 0">
          <swiper ref="swiper" :options="bannerOption">
            <swiper-slide class="banner" v-for="(i, index) in bannerList" :key="index">
              <img :src="i.resource_url" @click="goAdvertisementDetail(i.uuid)" />
            </swiper-slide>
          </swiper>
        </section>
        <section class="padding">
            <div class="tab-box" ref="tabBox" id="tab-box">
              <div class="tabs-content">
                <button
                  id="type"
                  class="tabs-item"
                  :class="{ 'is-active': tab.code === tabActive }"
                  v-for="(tab, index) in tabList"
                  :key="index"
                  @click="handleTab(tab)"
                >
                  <span>{{ tab.name }}</span>
                </button>
              </div>
            </div>
        </section>
      </div>
      <section class="lower-box">
          <div class="list" id="booking">
            <section>
                <div class="flex">
                  <div class="title-left-box">
                    <div class="title-left-upper-box">
                      <div class="title-wrap">
                        <div class="list-title">民宿訂房</div>
                      </div>
                    </div>
                    <div class="list-Content-title">
                    <img :src="require('../../assets/images/travel/booking.png')" width="24px" height="24px" />        
                    <span class="subtitle">Traiwan ⺠宿訂房</span>
                    </div>
                  </div>
                </div>
                <span class="readmore" @click="openExternalLink('travel_click_traiwan', 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Ftraiwan.com%2Fchannel%2Fuupay%2F&verify=d57fbb531dd34f85f97375b7e46372d01f34ed9f68070ff860d7404d4452add3')">
                    查看所有⺠宿 >
                </span>          
            </section>
            <section>
            <div class="speaker-box" @click="openExternalLink('travel_click_traiwan', 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Ftraiwan.com%2Fchannel%2Fuupay%2F&verify=d57fbb531dd34f85f97375b7e46372d01f34ed9f68070ff860d7404d4452add3')">
              <div><img :src="require('../../assets/images/travel/home.png')" /></div>
              <div><span>精選全台優質民宿，立即預訂！</span></div>
            </div>         
          </section>
          </div>   
          <div class="list second" id="coupon">
            <section>
               <div class="flex">
                  <div class="title-left-box">
                    <div class="title-left-upper-box">
                      <div class="title-wrap">
                        <div class="list-title">旅遊票券</div>
                      </div>
                    </div> 
                    <div class="list-Content-title">
                      <img :src="require('../../assets/images/travel/ticket.png')" width="41" height="10" />
                      <span class="subtitle">3TET 電票通</span>
                    </div>             
                  </div>
                </div>
                <span class="readmore" @click="openExternalLink('travel_click_3tet', 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Feasywallet.3tet.com&verify=81d8a1cccb83df4a735c13514aa191c4a0867f9729572334b18bffead5824aa9')">
                    查看所有票券 >
                </span>                              
            </section>
            <div>
                <swiper ref="swiper" :options="productOption">
                  <swiper-slide class="product" v-for="(i, index) in couponProductList" :key="index">
                    <div>
                      <div class="product-img-box"><center><img :src="i.image" @click="openExternalLink(i.eventName, i.url)"/></center></div>
                      <div><span class="title">{{i.title}}</span></div>
                    </div>                  
                  </swiper-slide>
                </swiper>
              </div>
          </div>
        <div class="partner">
          <div class="update">持續更新中，敬請期待</div>
        </div>
      </section>
    </div>
  </template>
  <script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
  import 'swiper/css/swiper.css';
  import { mapActions } from 'vuex';
  import { getBanner } from '../../api/api';
  import { clearTimeout, setTimeout } from 'timers';
  
  var scrollTimeout;
  
  export default {
    name: 'insurance',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        list: [],
        tabActive: 'booking',
        tabList: [
          {
            name : '民宿訂房',
            code : 'booking'
          },
          {
            name : '旅遊票券',
            code : 'coupon'
          }
        ],
        couponProductList: [
          {
            image: require('../../assets/images/travel/trainTickets.png'),
            title: '交通票券',
            subtitle: null,
            eventName: 'travel_click_3tet_traffic',
            url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Feasywallet.3tet.com%2Fproduct%2Fcate%2F78&verify=9793fc5a2c1646302a845c2ebb9f24b71c174c14e1ec4894bb08ee7f1060b47b'
          },
          {
            image: require('../../assets/images/travel/amusementParkTicket.png'),
            title: '樂園門票',
            subtitle: null,
            eventName: 'travel_click_3tet_playground',
            url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Feasywallet.3tet.com%2Fproduct%2Fcate%2F70&verify=9f7bb5f956e0b9afe5950f3740fc977a3d06fc5d02aedc0fe247338016ab7568'
          },
          {
            image: require('../../assets/images/travel/mealTickets.png'),
            title: '美食餐券',
            subtitle: null,
            eventName: 'travel_click_3tet_dish',
            url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Feasywallet.3tet.com%2Fproduct%2Fcate%2F68&verify=bdaacf28b489148c5875021e76a572bb8e24a540adb1cc3fd25e24512226d2da'
          }
        ],
        
        bannerList: [],
        bannerOption: {
          initialSlide: 0,
          spaceBetween: 10,
          slidesPerView: 'auto',
          centeredSlides: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        },
        productOption: {
          initialSlide: 0,
          spaceBetween: 16,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: false,
          freeMode: true,
        },
        dialogList: [],
        dialogOpen: false,
        dialogBorder: false,
      };
    },
    mounted() {
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { event: 'mainpage_click_travel' },
      });
      getBanner().then((res) => {
        if (res !== undefined && (res.error === null || res.error === undefined) && res.data.hasOwnProperty('13')) {
          this.bannerList = res.data['13'];
        }
      });
    },
    methods: {
      ...mapActions(['sentApp']),    
      handleTab(item) {
        this.tabActive = item.code;    
        const container = document.getElementById("container");
        if (this.tabActive === 'booking') {
          setTimeout(function() {
            var top = document.getElementById("booking").offsetTop - document.getElementById("upper-part").offsetHeight;
            container.scrollTo({left: 0, top: top, behavior: 'smooth'});
          }, 100);
        } else {
          setTimeout(function() {
            var top = document.getElementById("coupon").offsetTop - document.getElementById("upper-part").offsetHeight;
            container.scrollTo({left: 0, top: top, behavior: 'smooth'});
          }, 100);
        }
      },    
      goAdvertisementDetail(uuid) {
        this.sentApp({
          action: 'sendFirebaseEvent',
          payload: { event: 'click_ad_travel' },
        });
        this.sentApp({
          action: 'showAdvertisementDetail',
          payload: { uuid: uuid },
        });
      },
      openExternalLink(eventName, url) {
        this.sentApp({
          action: 'sendFirebaseEvent',
          payload: { event: eventName },
        });
        this.sentApp({
          action: 'openExternalBrowser',
          payload: { url: url },
        });
      },
      scrollEvent(event) {
        const couponSectionTop = document.getElementById("coupon").offsetTop - document.getElementById("upper-part").offsetHeight;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (event.srcElement.scrollTop >= couponSectionTop) {
              this.tabActive = this.tabList[1].code;
          } else {
              this.tabActive = this.tabList[0].code;
          }
        }, 100); 
      },
    },
  };
  </script>
  <style lang="scss" scoped>

.body-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: auto;
      background-color: rgb(253, 249, 242);
  }
  .swiper-pagination {
    position: relative;
    left: 0;
    top: 0;
  }
  
  .speaker-box {
    align-content: center;
    text-align: center;
    background-color: white;
    margin-left: 20px;
    margin-right: 20px;
    padding: 12px 0 12px 0;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
  }

  .speaker-box img {
    width: 44px;
    height: 44px;
  }

  .speaker-box span {
    font-family: PingFangTC-Medium;
    font-size: 16px;
  }
  
  .swiper-container {
    --swiper-theme-color: rgb(64, 64, 64);
  }
  
  .swiper-wrapper {
    align-items: center;;
  }
  
  .lower-box {
    background-color: rgb(253, 249, 242);
    height: 100vh;
  }
  
  .list .swiper-container {
    margin-left: 20px;
  }
  
  .product .subtitle {
    font-size: 12px;
    line-height: 8px;
    color: rgba(64, 64, 64, 0.75);
  }
  
  .product .title {
    font-size: 16px;
    line-height: 22px;
    color: rgba(64, 64, 64, 1);
    white-space: pre-line;
  }
  
  .product-img-box {
    align-items: right;
    flex-direction: column;
    justify-content: center;
  }
  
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
  
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8pt;
  }
  
  .upper-part {
    position: sticky;
    top: 0; /* Don't forget this, required for the stickiness */
    background-color: white;
    z-index: 997;
    background-image: url('../../assets/images/travel/background.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .product-img-box img {
    width: 44px;
    height: 44px;
  }
  
  .swiper-slide {
    width: 80%;
  }
  
  .product {
    margin: 4px;
    width: 120px;
    height: 100px;
    text-align: center;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    margin-right: 20px;
    border-radius: 4px;
  }
  
  .banner-wrap {
    padding-top: 56px;
    background-image: url('../../assets/images/travel/bebe.png');
    background-position: right 20px top 2px;
    background-size: 83px 83px;
    background-repeat: no-repeat;
  }
  
  .readmore {
    font-size: 14px;
    font-family: PingFangTC-Medium;
    color: rgba(64, 64, 64, 0.75);
    margin-right: 10px;
  }
  
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 12px;
  }
  
  .title-left-upper-box {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  
  .padding {
    padding: 36px 20px 0px 20px;
  }
  
  .title-left-box {
    display: flex;
    flex-direction: column;
  }
  
  .title-left-box .subtitle {
    margin-top: 8px;
    font-size: 12px;
    color: rgba(64, 64, 64, 0.75);
  }
  
  .title {
    font-size: 20px;
    color: rgb(64, 64, 64);
    font-family: PingFangTC-Semibold;
    text-align: center;
  
    span {
      color: rgb(0, 122, 200);
    }
  }
  
  .tabs-content button {
    all: unset;
    cursor: pointer;
    margin-right: 20px;
    padding: 8px;
    color: rgba(64, 64, 64, 0.75);
  }
  
  .tabs-content button.is-active {
    border-bottom-color: rgb(0, 122, 200);
    border-width: 2px;  
    border-bottom-style: solid;
  }
  
  .tabs-content button.is-active span {
    color: rgb(0, 122, 200);
  }
  
  .tabs-content button span {
    font-size: 16px;
  }
  
  .text {
    color: rgb(64, 64, 64);
    font-family: PingFangTC-Regular;
    font-size: 14px;
  }
  
  .list {
    margin: 0 0 0 0;
    padding-top: 12px;
    section:first-child {
      padding: 16px 12px 12px 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  
    .title-wrap {
      .list-subtitle {
        font-family: PingFangTC-Regular;
        color: rgba(64, 64, 64, 0.75);
        margin-top: 4px;
        font-size: 18px;
      }

      .list-title {
        font-family: PingFangTC-Medium;
        font-size: 18px;
      }
    }
  
    .btn {
      width: revert;
      height: 32px;
      padding: 0px 16px 0px 16px;
      white-space: nowrap;
    }
  
    .arrow {
      transform: rotate(180deg);
    }
  }
  
  .list-detail {
    transition: all 0.1s ease-in-out;
    background-color: rgba(64, 64, 64, 0.05);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    //padding: 12px;
    height: 0;
    opacity: 0;
    text-align: justify;
    color: rgba(64, 64, 64, 0.75);
    font-size: 14px;
    font-family: PingFangTC-Regular;
  }
  
  .arrow {
      transform: revert;
  }
  
  .openDetail {
    height: auto;
    opacity: 1;
  
    .arrow {
      transform: none;
    }
  }
  
  ul {
    padding: 0px;
    margin-left: 12px;
  }
  
  ul li {
      /*
       * We want the bullets outside of the list,
       * so the text is aligned. Now the actual bullet
       * is outside of the list’s container
       */
      list-style-position: outside;
      list-style-type: "•";
      /*
       * Because the bullet is outside of the list’s
       * container, indent the list entirely
       */
      margin-right: 5px;
      padding: 0px;
      font-family: PingFangTC-Regular;
  }
  
  li span {
    position: relative;
    left: 5px;
  }
  
  .second {
    margin-top: 0px;
  }
  
  .partner {
    margin-top: 24px;
    height: 20%;
  
    .update {
      font-family: PingFangTC-Regular;
      color: rgb(199, 199, 199);
      justify-content: center;
      margin-top: 56px;
      text-align: center;
    }
  }
  
  .bill-button {
    position: fixed;
    bottom: 16px;
    font-family: PingFangTC-Medium;
    color: white;
    font-size: 14;
    background-color: rgb(40, 40 ,40);
    border-radius: 28px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 998;
  }
  
  .bill-button-content {
    img {
      padding: 12px 0 12px 12px;
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }
  
    span {
      padding: 14px 16px 14px 0;
      vertical-align: middle;
    }
  }
  .block {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 20px 16px 20px;
    padding: 20px;
    font-size: 16px;
    font-family: PingFgangTC-Medium;
    display: flex;
    align-items: center;
    box-shadow: 0 4pt 8pt 0 rgba(0, 0, 0, 0.05);
  }
  
  .block img {
    width: 24px;
    height: 24px;
    margin-right: 8pt;
  }
  
  .block:active, .block-shadows:active {
    background: rgba(0, 0, 0, 0.05);
  }
  
  .text-gray2 {
    color: rgba(64, 64, 64, 1);
    min-width: 90px;
  }
  
  .arrow-right {
    margin-left: auto;
    width: 24px;
    height: 24px;
  }
  
  .up {
    animation: slideUp 0.3s ease-in-out both;
  }
  
  .down {
    animation: slideDown 0.3s ease-in-out both;
  }
  
  @keyframes slideUp {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0);
    }
  }
  
  @keyframes slideDown {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(100%);
    }
  }

  .list-Content-title {
    margin-top: 4px;
    img {
      margin-right: 4px;
      vertical-align: middle;
    } 
  }
  
  </style>
  